{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Farvevælger",
  "twoDimensionalSlider": "2D-skyder",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
